import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { Form } from 'semantic-ui-react';
import { getCountryOptions } from './AddressForm.utils';
import './AddressForm.css';
var defaultProps = {
  showCountryInput: false
};
function AddressForm(_ref) {
  var country = _ref.country,
    state = _ref.state,
    city = _ref.city,
    postalCode = _ref.postalCode,
    line1 = _ref.line1,
    line2 = _ref.line2,
    onChange = _ref.onChange,
    showCountryInput = _ref.showCountryInput;
  function onFieldChange(e, _ref2) {
    var name = _ref2.name,
      value = _ref2.value;
    onChange(_defineProperty({}, name, value));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Input, {
    fluid: true,
    label: "Address 1",
    placeholder: "Address 1",
    name: "line1",
    onChange: onFieldChange,
    value: line1,
    required: true
  }), /*#__PURE__*/React.createElement(Form.Input, {
    fluid: true,
    label: "Address 2 (optional)",
    placeholder: "Address 2",
    name: "line2",
    onChange: onFieldChange,
    value: line2
  }), /*#__PURE__*/React.createElement(Form.Input, {
    fluid: true,
    label: "City",
    placeholder: "City",
    name: "city",
    onChange: onFieldChange,
    value: city,
    required: true
  }), /*#__PURE__*/React.createElement(Form.Select, {
    fluid: true,
    label: "State",
    placeholder: "State",
    name: "state",
    onChange: onFieldChange,
    value: state,
    options: getCountryOptions(),
    required: true,
    search: true,
    selection: true
  }), /*#__PURE__*/React.createElement(Form.Input, {
    fluid: true,
    label: "Postal Code",
    placeholder: "Postal Code",
    name: "postalCode",
    onChange: onFieldChange,
    value: postalCode,
    required: true
  }), showCountryInput && /*#__PURE__*/React.createElement(Form.Input, {
    fluid: true,
    label: "Country",
    placeholder: "Country",
    name: "country",
    onChange: onFieldChange,
    value: country,
    required: true
  }));
}
AddressForm.defaultProps = defaultProps;
export default AddressForm;